var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M34.484 12.984a1.5 1.5 0 0 0-1.045 2.576L40.879 23H18.5a1.5 1.5 0 1 0 0 3h22.379l-7.439 7.439a1.5 1.5 0 1 0 2.121 2.121l10-10a1.5 1.5 0 0 0 0-2.121l-10-10a1.5 1.5 0 0 0-1.076-.455zM3.5 23a1.5 1.5 0 0 0 0 3 1.5 1.5 0 0 0 0-3zm5 0a1.5 1.5 0 0 0 0 3 1.5 1.5 0 0 0 0-3zm5 0a1.5 1.5 0 0 0 0 3 1.5 1.5 0 0 0 0-3z"}));
}

ArrowRight.defaultProps = {"viewBox":"0 0 48 48","fill":"#ffffff","xmlnsV":"https://vecta.io/nano"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
